import { Dashboard } from '../features/performance/dashboard/dashboard';

/** `/marketing/performance` — the campaign performance dashboard; data sources and snapshot live under /data. */
export default function Performance() {
  return <Dashboard />;
}
